import { Locale } from '@rbx/intl';
import TranslationNamespace from '../enums/TranslationNamespace';
import TranslationResourceProvider from '../implementations/TranslationResourceProvider';
import {
  defaultLocale,
  defaultLocaleInfo,
  defaultPageLayoutTranslationNamespaces,
  pageTranslationNamespaces,
} from '../constants/translationResourceConstants';

export const translationResourceProvider = new TranslationResourceProvider(defaultLocaleInfo);

export async function loadTranslationResources(
  namespaces: TranslationNamespace[],
  locale: Locale = defaultLocale,
) {
  const translationResources = translationResourceProvider.getTranslationResources(
    namespaces,
    locale,
  );

  if (translationResources !== null) {
    return translationResources;
  }

  return translationResourceProvider.loadTranslationResources(namespaces, locale);
}

export async function loadPageLayoutTranslationResources(locale: Locale = defaultLocale) {
  return loadTranslationResources(defaultPageLayoutTranslationNamespaces, locale);
}

export async function loadPageTranslationResources(locale: Locale = defaultLocale) {
  return loadTranslationResources(pageTranslationNamespaces, locale);
}
